PJQ.views.productionQuantities.ProductionQuantitiesAddModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-production-quantities-add'),
        width: '95%',
        maxWidth: 1000,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-cancel': 'close',
        'click .btn-add-production-quantity': 'addProductionQuantity',
        'click .btn-save': 'saveProductionQuantities',
        'click .btn-import': 'importFile'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.productionQuantities.ProductionQuantities(null, {
                projectId: this.options.project.id
            });
        }

        this.costCodes = await this.options.project.fetchCostCodes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();
        this.subJobs = await this.options.project.fetchSubJobs();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }
    },
    renderData: function () {
        return {
            collection: this.collection,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.dataTable = new PJQ.views.productionQuantities.AddProductionQuantitiesDatatable({
            el: this.$('.add-production-quantities-data'),
            rowId: "cid",
            columns: this.getColumns(),
            data: this.collection.models,
            costCodes: this.costCodes,
            unitsOfMeasure: this.unitsOfMeasure,
            subJobs: this.subJobs,
            paging: false,
            afterDataTableRender: _.bind(function () {
                this.renderInputs();
            }, this),
            onRowRemoved: _.bind(function () {
                this.renderInputs();
            }, this),
            headerData: _.bind(function () {
                return {
                    project: this.options.project
                };
            }, this),
            onDeleteProductionQuantity: (row) => {
                this.deleteProductionQuantity(row);
            },
            order: [[1, 'asc']],
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Delete',
                        onClick: (row) => {
                            this.deleteProductionQuantity(row.data());
                        },
                        isDanger: true
                    }
                ]
            }
        });
    },
    getColumns: function (includeAllColumns = false) {
        return [
            {
                "columnData": "subJobId",
                "title": "Sub Job",
                "visible": _.size(this.subJobs.models) > 0,
                "width": "15%",
                "render": _.bind(function (data, type, row) {
                    return '<select class="select-sub-job form-control"></select>';
                }, this)
            },
            {
                "columnData": "costCodeId",
                "title": "Cost Code",
                "width": '15%',
                "render": (data, type, row) => {
                    let res = '<div class="d-flex"><select class="select-cost-code form-control"></select>';

                    res += '</div>';
                    return res;
                }
            },
            {
                "columnData": "description",
                "data": "attributes.description",
                "width": '20%',
                "title": "Description",
                "render": _.bind(function (data, type, row) {
                    return '<input type="text" class="form-control input-description" maxlength="256" value="' + row.get('description').replace(/"/g, '&quot;') + '" data-p-bind="description">';
                }, this)
            },
            {
                "columnData": "unitOfMeasure",
                "data": "attributes.unitId",
                "title": "Unit",
                "width": "20%",
                "className": "text-align-center",
                "render": (data, type, row) => {
                    return '<select class="select-unit-type form-control"></select>';
                }
            },
            {
                "columnData": "quantity",
                "data": "attributes.quantity",
                "width": "10%",
                "title": "Quantity",
                "orderable": false,
                "searchable": false,
                "className": "text-align-center",
                "render": (data, type, row) => {
                    return '<input type="text" class="form-control input-decimal input-quantity" value="' + row.get('quantity') + '" data-p-bind="quantity" placeholder="0">';
                }
            },
            {
                "title": '',
                "orderable": false,
                "searchable": false,
                "width": "10%",
                "className": "text-center",
                "visible": true,
                "render": _.bind(function (data, type, row) {
                    return `<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-danger btn-delete-production-quantity ml-1 fs-14"><span class="fal fa-trash"></span></button></div>`;
                }, this)
            }
        ];
    },
    renderInputs: function () {
        PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-decimal'), 2);

        if (!this.binder) {
            this.binder = new PJQ.Binder(this.$el, this.collection, {
                delegate: true,
                modelSelectorAttribute: 'id',
                idAttribute: 'cid',
                useDecimalPercentFields: true,
                watchElements: [
                    'input'
                ]
            });
        }

        if (_.size(this.subJobs.models) > 0) {
            this.subJobPickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                pickerSelector: '.select-sub-job',
                valueAttribute: 'subJobId',
                selectPickerOptions: {
                    noneSelectedText: 'Parent Job',
                    isLiveSearch: true,
                    isIntChoices: true,
                    size: 8,
                    isDisabled: _.bind(function (model) {
                        return false;
                    }, this),
                    choices: _.union([{name: '', choices: {id: 0, name: 'Parent Job'}}], [{
                        name: 'Sub Jobs', choices: _.map(this.subJobs.models, function (subJob) {
                            return {
                                id: subJob.id,
                                name: subJob.get('name'),
                                subtext: subJob.get('code')
                            }
                        }, this)
                    }])
                },
                onChange: _.bind(function (model, value) {
                    model.set('subJobId', value > 0 ? value : null);
                    model.set('costCodeId', 0);

                    let costCodePicker = this.costCodeSelectorCollection.pickers[model.cid];
                    costCodePicker.render();

                    // this.nextInput('subJob', model);
                }, this)
            });
        }

        this.costCodeSelectorCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
            pickerSelector: '.select-cost-code',
            valueAttribute: 'costCodeId',
            selectPickerOptions: {
                isLiveSearch: true,
                isIntChoices: true,
                hideDisabled: false,
                isDisabled: _.bind(function (model) {
                    return false;
                }, this),
                choices: _.bind(function (model) {
                    return this.getCostCodeOptions(model)
                }, this)
            },
            onChange: _.bind(function (model, value) {
                model.set('costCodeId', value);

                // this.nextInput('costCode', model);
            }, this)
        });

        new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
            pickerSelector: '.select-unit-type',
            valueAttribute: 'unitId',
            selectPickerOptions: {
                isIntChoices: true,
                isDisabled: function (model) {
                    return !model.isNew();
                },
                choices: _.bind(function (model) {
                    return _.map(this.unitsOfMeasure.models, function (unit) {
                        return {
                            id: unit.id,
                            name: unit.get('name')
                        }
                    });
                }, this)
            },
            onChange: _.bind(function (model, value) {
                model.set('unitId', value);

                // this.nextInput('unitType', model);
            }, this)
        });
    },
    getCostCodeOptions: function (model) {
        let subJob = this.subJobs.get(model.get('subJobId')),
            costCodes = [],
            filteredCostCodes = _.filter(this.costCodes.models, function (costCode) {
                if (subJob == null) {
                    return costCode.get('subJobId') == null
                }
                return costCode.get('subJobId') === subJob.id;
            });

        if (_.size(filteredCostCodes) === 0) {
            return [{
                id: 0,
                name: 'No cost codes found',
                disabled: true
            }];
        }

        _.each(filteredCostCodes.sort((c1, c2) => {
            return PJQ.helpers.sortHelpers.sortAlphaNum(c1.get('code'), c2.get('code'));
        }), function (costCode) {
            let choice = {
                id: costCode.id,
                name: costCode.getDisplayName()
            };
            costCodes.push(choice);
        }, this);
        return costCodes
    },
    addProductionQuantity: function () {
        let newModel = new PJQ.models.productionQuantities.ProductionQuantity({
            projectId: this.options.project.id,
            quantity: 0,
            description: ''
        });
        this.collection.add(newModel);
        this.dataTable.addRow(newModel)
        this.dataTable.render();
    },
    saveProductionQuantities: function () {
        if (!this.validate())
            return;
        let loader = new PJQ.Loader(this.$('.modal-body'));

        let newModels = _.filter(this.collection.models, (model) => model.isNew()),
            newModelsJSON = _.map(newModels, (model) => model.toJSON());

        this.collection.saveBulk(newModelsJSON, (newProductionQuantities) => {
            if (typeof this.options.onSave == 'function') {
                this.options.onSave(newProductionQuantities);
            }
            loader.remove();
            this.removeModal();
        })
    },
    importFile: function () {
        this.renderUploader();
    },
    renderUploader: function () {
        let $uploader = this.$('.import-uploader');
        if (this.fileUploader == null) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: $uploader,
                useApiV2: true,
                allowedExtensions: ['xls', 'xlsx', 'csv'],
                uploadTemplateCallback: () => {
                    PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'productionquantities'
                        },
                        {
                            endpoint: 'import'
                        },
                        {
                            endpoint: 'template'
                        }
                    ]), {isAPIv2: true});
                },
                maxFiles: 1,
                style: 'grid',
                onSuccess: _.bind(function (file) {
                    let loader = new PJQ.Loader($uploader);
                    let uploadId = file.uploadId;
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'projects',
                                value: PJQ.app.session.project.id,
                            },
                            {
                                endpoint: 'productionquantities'
                            },
                            {
                                endpoint: 'import',
                                value: uploadId
                            }
                        ]),
                        isAPIv2: true
                    }).post().done(_.bind(function (result) {
                        loader.remove();
                        this.fileUploader.remove();
                        this.subJobs.add(result.subJobs);
                        this.costCodes.add(result.costCodes);
                        this.collection.add(result.lineItems);
                        this.dataTable.render();
                    }, this)).fail((err) => {
                        if (err && err.responseJSON) {
                            loader.remove();
                            let file = this.fileUploader.collection.models[0];
                            this.fileUploader.collection.remove(file);
                            this.fileUploader.render();
                            this.fileUploader.showError(err.responseJSON.message, 10000);
                        }
                    });
                }, this)
            });
        } else {
            // Hide file uploader if button is clicked again
            $uploader.attr('hidden', !$uploader.attr('hidden'));
        }
        let self = this;
        $uploader.find('.btn-download-template').off('click').on('click', self.downloadImportTemplate);
    },
    validate: function () {
        let isValid = true;

        _.each(this.collection.models, (model) => {
            isValid = isValid && this.validateProductionQuantity(model);
        })

        return isValid;
    },
    validateProductionQuantity: function (productionQuantity) {
        if (this.dataTable == null) {
            return true;
        }

        let row = this.dataTable.getRow(productionQuantity.cid),
            data = row?.data(),
            result = true,
            updateCell = _.bind(function ($cell, isValid) {
                if (isValid) {
                    $cell.removeClass('bg-danger-transparent');
                } else {
                    $cell.addClass('bg-danger-transparent');
                }
                result = result && isValid;
            }, this);

        if (data == null || data.get('delete')) {
            return true;
        }

        if (row != null) {
            let costCodeCol = 0,
                uomCol = 2;
            if (_.size(this.subJobs.models) > 0) {
                costCodeCol++;
                uomCol++;
            }

            updateCell($(row.nodes()[0]).find('td:eq(' + costCodeCol + ')'), productionQuantity.get('costCodeId') > 0);
            updateCell($(row.nodes()[0]).find('td:eq(' + uomCol + ')'), productionQuantity.get('unitId') > 0);
        }
        return result;
    },
    deleteProductionQuantity: function (row) {
        let productionQuantity = row.data();
        productionQuantity.destroy();
        this.dataTable.removeRow(row);
    },
    close: function () {
        if (_.size(this.collection.models) > 0) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveProductionQuantities();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.productionQuantities.InstalledQuantitiesAddModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-installed-quantities-add'),
        width: '95%',
        maxWidth: 1000,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-cancel': 'close',
        'click .btn-save': 'save'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.productionQuantities.InstalledQuantities(null, {
                projectId: this.options.project.id
            });
        }

        if (this.options.productionQuantities == null) {
            this.options.productionQuantities = new PJQ.collections.productionQuantities.ProductionQuantities(null, {
                projectId: this.options.project.id
            })
        }

        this.costCodes = await this.options.project.fetchCostCodes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();
        this.subJobs = await this.options.project.fetchSubJobs();

        if (!this.options.productionQuantities.isFetched) {
            this.options.productionQuantities.fetch({
                success: _.bind(function () {
                    if (this.options.productionQuantityId > 0) {
                        this.productionQuantity = this.options.productionQuantities.get(this.options.productionQuantityId);
                    }

                    this.isFetched = true;
                    this.render();
                }, this)
            });
        } else {
            this.isFetched = true;
            this.render();
        }
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canEdit = this.options.project.permissions.hasPermission('productionQuantities.canEdit');
        this.options.canAdd = this.options.project.permissions.hasPermission('productionQuantities.canAdd');
        this.options.isAdmin = this.options.project.permissions.hasPermission('productionQuantities.isAdmin');
    },
    renderData: function () {
        return {
            collection: this.collection,
            productionQuantities: this.options.productionQuantities,
            productionQuantity: this.productionQuantity,
            costCodes: this.costCodes,
            isFetched: this.isFetched,
            canAdd: this.options.canAdd,
            canEdit: this.options.canEdit,
            isAdmin: this.options.isAdmin
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.addInstalledQuantitiesView = new PJQ.views.productionQuantities.InstalledQuantitiesAdd({
            el: this.$('.installed-quantities-view'),
            collection: this.collection,
            productionQuantityId: this.options.productionQuantityId,
            productionQuantities: this.options.productionQuantities,
            timeCardId: this.options.timeCardId,
            project: this.options.project,
            onSave: (newQuantities) => {
                if(typeof this.options.onSave === 'function') {
                    this.options.onSave(newQuantities);
                }

                this.removeModal();
            }
        })
    },
    save: function () {
        this.addInstalledQuantitiesView.saveQuantities();
    },
    close: function () {
        if (_.size(this.collection.models) > 0 && (this.options.canAdd || this.options.canEdit)) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.addInstalledQuantitiesView.saveQuantities();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.productionQuantities.TimeCardQuantitiesAddModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-time-card-quantities-add'),
        subTemplates: {
            timeCardQuantities: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'time-card-quantities')
        },
        width: '95%',
        maxWidth: 1000,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-cancel': 'close',
        'click .btn-save': 'save'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        if (this.collection == null) {
            this.collection = new PJQ.collections.productionQuantities.InstalledQuantities(null, {
                projectId: this.options.project.id
            });
        }

        if (this.options.productionQuantities == null) {
            this.options.productionQuantities = new PJQ.collections.productionQuantities.ProductionQuantities(null, {
                projectId: this.options.project.id
            });
        }

        this.costCodes = await this.options.project.fetchCostCodes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();
        this.subJobs = await this.options.project.fetchSubJobs();

        if (!this.options.productionQuantities.isFetched) {
            this.options.productionQuantities.fetch({
                success: _.bind(function () {
                    this.isFetched = true;
                    this.render();
                }, this)
            });
        } else {
            this.isFetched = true;
            this.render();
        }
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }
    },
    renderData: function () {
        return {
            collection: this.collection,
            productionQuantities: this.options.productionQuantities,
            productionQuantity: this.productionQuantity,
            costCodes: this.costCodes,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.quantityViews = [];

        let $outer = this.$('.time-card-quantity-views');
        $outer.empty();
        _.each(this.options.timeCards.models, (timeCard) => {
            this.renderSubTemplate(true, this.options.subTemplates.timeCardQuantities, $outer, {
                timeCard: timeCard,
                collapse: _.size(this.options.timeCards.models) > 2,
                contact: timeCard.get('contact')
            }, _.bind(function (el) {
                let quantitiesView = new PJQ.views.productionQuantities.InstalledQuantitiesAdd({
                    el: el.find('.quantities-outer'),
                    project: this.options.project,
                    timeCardId: timeCard.id
                });

                this.quantityViews.push(quantitiesView);
            }, this));
        });
    },
    validate: function() {
        let isValid = true;
        _.each(this.quantityViews, (view) => {
            isValid = isValid && view.validate();
        });

        return isValid;
    },
    save: function () {
        if(!this.validate()) {
            return;
        }

        _.each(this.quantityViews, (view) => {
            if(_.size(view.collection.models) > 0) {
                this.collection.add(view.collection.models);
            }
        });

        if(_.size(this.collection.models) > 0){
            this.collection.saveBulk(_.map(this.collection.models, (model) => model.toJSON()), (newQuantities) => {
                PJQ.notifications.notify.successNotify({
                    message: 'Quantities saved successfully'
                });

                if(typeof this.options.onSave === 'function') {
                    this.options.onSave(newQuantities);
                }
                this.removeModal();
            });
        }
    },
    close: function () {
        let isDirty = _.find(this.quantityViews, (view) => {
            return _.size(view.collection.models) > 0;
        });
        if (isDirty) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.productionQuantities.InstalledQuantitiesAdd = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'installed-quantities-add'),
        model: null,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-add-quantity': 'addQuantity',
        'click .btn-delete-quantity': 'deleteQuantityClicked',
        'click .btn-import': 'importFile'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.productionQuantities.InstalledQuantities(null, {
                projectId: this.options.project.id
            });
        }

        if (this.options.productionQuantities == null) {
            this.options.productionQuantities = new PJQ.collections.productionQuantities.ProductionQuantities(null, {
                projectId: this.options.project.id
            })
        }

        this.costCodes = await this.options.project.fetchCostCodes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();
        this.subJobs = await this.options.project.fetchSubJobs();

        if (!this.options.productionQuantities.isFetched) {
            this.options.productionQuantities.fetch({
                success: _.bind(function () {
                    if (this.options.productionQuantityId > 0) {
                        this.productionQuantity = this.options.productionQuantities.get(this.options.productionQuantityId);
                    }

                    this.isFetched = true;
                    this.render();
                }, this)
            });
        } else {
            this.isFetched = true;
            this.render();
        }
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canEdit = this.options.project.permissions.hasPermission('productionQuantities.canEdit');
        this.options.canAdd = this.options.project.permissions.hasPermission('productionQuantities.canAdd');
        this.options.isAdmin = this.options.project.permissions.hasPermission('productionQuantities.isAdmin');
    },
    renderData: function () {
        return {
            canAdd: this.options.canAdd
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderDatatable();
    },
    renderDatatable: function() {
        this.dataTable = new PJQ.views.productionQuantities.AddInstalledQuantitiesDatatable({
            el: this.$('.add-production-quantity-installed-quantities-data'),
            rowId: "cid",
            columns: this.getColumns(),
            data: this.collection.models.filter((model) => !model.get('delete')),
            costCodes: this.costCodes,
            unitsOfMeasure: this.unitsOfMeasure,
            subJobs: this.subJobs,
            paging: false,
            afterDataTableRender: _.bind(function () {
                this.renderInputs();
            }, this),
            onRowRemoved: _.bind(function () {
                this.renderInputs();
            }, this),
            headerData: _.bind(function () {
                return {
                    project: this.options.project
                };
            }, this),
            order: [[1, 'asc']],
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Delete',
                        onClick: (row) => {
                            this.deleteQuantity(row.data());
                        },
                        isDanger: true
                    }
                ]
            }
        });
    },
    getColumns: function () {
        let includedColumns = ['subJobId', 'costCodeId', 'unitOfMeasure', 'quantity', 'description', 'installedOn'],
            columns = [];

        if (this.options.productionQuantityId > 0) {
            includedColumns = ['quantity', 'description', 'installedOn'];
        }

        _.each(includedColumns, (column) => {
            switch (column) {
                case 'subJobId':
                    columns.push({
                        "columnData": "subJobId",
                        "title": "Sub Job",
                        "visible": _.size(this.subJobs.models) > 0,
                        "width": "15%",
                        "render": _.bind(function (data, type, row) {
                            return '<select class="select-sub-job form-control"></select>';
                        }, this)
                    });
                    break;
                case 'costCodeId':
                    columns.push({
                        "columnData": "costCodeId",
                        "title": "Cost Code",
                        "width": '25%',
                        "render": (data, type, row) => {
                            let res = '<div class="d-flex"><select class="select-cost-code form-control"></select>';

                            res += '</div>';
                            return res;
                        }
                    });
                    break;
                case 'unitOfMeasure':
                    columns.push({
                        "columnData": "unitOfMeasure",
                        "data": "attributes.unitId",
                        "title": "Unit",
                        "width": "100px",
                        "className": "text-align-center",
                        "render": (data, type, row) => {
                            return '<select class="select-unit-type form-control"></select>';
                        }
                    });
                    break;
                case 'quantity':
                    columns.push({
                        "columnData": "quantity",
                        "data": "attributes.quantity",
                        "title": "Quantity Installed",
                        "orderable": false,
                        "searchable": false,
                        "className": "text-align-center",
                        "render": (data, type, row) => {
                            return '<input type="text" class="form-control input-decimal input-quantity" value="' + row.get('quantity') + '" data-p-bind="quantity" placeholder="0" ' + (!row.isNew() && !this.options.canEdit ? 'disabled' : '') + '>';
                        }
                    });
                    break;
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "width": '20%',
                        "title": "Description",
                        "render": _.bind(function (data, type, row) {
                            return '<input type="text" class="form-control input-description" maxlength="256" value="' + row.get('description').replace(/"/g, '&quot;') + '" data-p-bind="description" ' + (!row.isNew() && !this.options.canEdit ? 'disabled' : '') + '>';
                        }, this)
                    });
                    break;
                case 'installedOn':
                    columns.push({
                        "columnData": "installedOn",
                        "data": "attributes.installedOn",
                        "title": "Installed On",
                        "width": '120px',
                        "render": (data, type, row) => {
                            return '<div class="input-group"><input type="text" class="form-control input-installed-on" ' + (!row.isNew() && !this.options.canEdit ? 'disabled' : '')  + '/></div>';
                        }
                    });
                    break;
            }
        });

        columns.push({
            "title": '',
            "orderable": false,
            "searchable": false,
            "width": "80px",
            "className": "text-center",
            "visible": true,
            "render": _.bind(function (data, type, row) {
                if(row.isNew() || this.options.isAdmin) {
                    return `<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-danger btn-delete-quantity ml-1 fs-14"><span class="fal fa-trash"></span></button></div>`;
                }

                return '';
            }, this)
        })

        return columns;
    },
    renderInputs: function () {
        PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-decimal'), 2);

        let filteredCostCodes = _.filter(this.costCodes.models, (costCode) => {
            return this.options.productionQuantities.findWhere({costCodeId: costCode.get('id')}) != null;
        });

        let filteredSubJobs = _.filter(this.subJobs.models, (subJob) => {
            return _.find(filteredCostCodes, (costCode) => {
                return costCode.get('subJobId') === subJob.get('id');
            });
        });

        if (!this.binder) {
            this.binder = new PJQ.Binder(this.$el, this.collection, {
                delegate: true,
                modelSelectorAttribute: 'id',
                idAttribute: 'cid',
                useDecimalPercentFields: true,
                watchElements: [
                    'input'
                ]
            });
        }

        if (_.size(this.subJobs.models) > 0) {
            this.subJobPickerCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
                pickerSelector: '.select-sub-job',
                valueAttribute: 'subJobId',
                selectPickerOptions: {
                    noneSelectedText: 'Parent Job',
                    isLiveSearch: true,
                    isIntChoices: true,
                    defaultValue: (model) => {
                        if(model.get('subJobId') > 0) {
                            return model.get('subJobId');
                        }
                        let productionQuantity = this.options.productionQuantities.findWhere({id: model.get('productionQuantityId')}),
                            costCode = this.costCodes.get(productionQuantity?.get('costCodeId'));

                        return costCode?.get('subJobId');
                    },
                    size: 8,
                    isDisabled: _.bind(function (model) {
                        return !model.isNew();
                    }, this),
                    choices: _.union([{name: '', choices: {id: 0, name: 'Parent Job'}}], [{
                        name: 'Sub Jobs', choices: _.map(filteredSubJobs, function (subJob) {
                            return {
                                id: subJob.id,
                                name: subJob.get('name'),
                                subtext: subJob.get('code')
                            }
                        }, this)
                    }])
                },
                onChange: _.bind(function (model, value) {
                    model.set('subJobId', value > 0 ? value : null);
                    model.set('costCodeId', 0);
                    model.set('unitId', 0);
                    model.set('productionQuantityId', 0);

                    let costCodePicker = this.costCodeSelectorCollection.pickers[model.cid],
                        uomPicker = this.uomSelectorCollection.pickers[model.cid];
                    costCodePicker.render();
                    uomPicker.render();

                    // this.nextInput('subJob', model);
                }, this)
            });
        }

        this.costCodeSelectorCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
            pickerSelector: '.select-cost-code',
            valueAttribute: 'costCodeId',
            selectPickerOptions: {
                isLiveSearch: true,
                isIntChoices: true,
                hideDisabled: false,
                defaultValue: (model) => {
                    if(model.get('costCodeId') > 0) {
                        return model.get('costCodeId');
                    }
                    let productionQuantity = this.options.productionQuantities.findWhere({id: model.get('productionQuantityId')});

                    return productionQuantity?.get('costCodeId');
                },
                isDisabled: _.bind(function (model) {
                    return !model.isNew();
                }, this),
                choices: _.bind(function (model) {
                    return this.getCostCodeOptions(model)
                }, this)
            },
            onChange: _.bind(function (model, value) {
                model.set('costCodeId', value);
                model.set('unitId', 0);
                model.set('productionQuantityId', 0);

                let uomPicker = this.uomSelectorCollection.pickers[model.cid];
                uomPicker.render();

                // this.nextInput('costCode', model);
            }, this)
        });

        this.uomSelectorCollection = new PJQ.inputs.SelectPickerCollection(this.$el, this.collection.models, {
            pickerSelector: '.select-unit-type',
            valueAttribute: 'unitId',
            selectPickerOptions: {
                isIntChoices: true,
                isDisabled: function (model) {
                    return !model.isNew();
                },
                defaultValue: (model) => {
                    if(model.get('unitId') > 0) {
                        return model.get('unitId');
                    }

                    let productionQuantity = this.options.productionQuantities.findWhere({id: model.get('productionQuantityId')});

                    return productionQuantity?.get('unitId');
                },
                choices: _.bind(function (model) {
                    let productionQuantity = model.get('productionQuantityId') > 0 ? this.options.productionQuantities.findWhere({id: model.get('productionQuantityId')}) : null,
                        selectedCostCode = this.costCodes.get(productionQuantity ? productionQuantity.get('costCodeId') : model.get('costCodeId'));

                    if (selectedCostCode == null) {
                        return [];
                    }

                    let filteredUOM = _.filter(this.unitsOfMeasure.models, (unit) => {
                        let productionQuantity = this.options.productionQuantities.findWhere({
                            costCodeId: selectedCostCode.get('id'),
                            unitId: unit.get('id')
                        });

                        return productionQuantity != null;
                    });

                    return _.map(filteredUOM, function (unit) {
                        return {
                            id: unit.id,
                            name: unit.get('name')
                        };
                    });
                }, this)
            },
            onChange: _.bind(function (model, value) {
                let productionQuantity = this.options.productionQuantities.findWhere({
                    costCodeId: model.get('costCodeId'),
                    unitId: value
                });
                model.set('unitId', value);
                model.set('productionQuantityId', productionQuantity.id);

                // this.nextInput('unitType', model);
            }, this)
        });

        new PJQ.inputs.DatePickerCollection(this.$el, this.collection.models, {
            pickerSelector: '.input-installed-on',
            valueAttribute: 'installedOn',
            datePickerOptions: {
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
                },
            },
            onChange: _.bind(function (model, value) {
                model.set('installedOn', value);
                ``
                // this.nextInput('unitType', model);
            }, this)
        });
    },
    importFile: function () {
        this.renderUploader();
    },
    renderUploader: function () {
        let $uploader = this.$('.import-uploader');
        if (this.fileUploader == null) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: $uploader,
                useApiV2: true,
                allowedExtensions: ['xls', 'xlsx', 'csv'],
                uploadTemplateCallback: () => {
                    PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'projects',
                            value: PJQ.app.session.project.id,
                        },
                        {
                            endpoint: 'productionquantities'
                        },
                        {
                          endpoint: 'installed'
                        },
                        {
                            endpoint: 'import'
                        },
                        {
                            endpoint: 'template'
                        }
                    ]), {isAPIv2: true});
                },
                maxFiles: 1,
                style: 'grid',
                onSuccess: _.bind(function (file) {
                    let loader = new PJQ.Loader($uploader);
                    let uploadId = file.uploadId;
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'projects',
                                value: PJQ.app.session.project.id,
                            },
                            {
                                endpoint: 'productionquantities'
                            },
                            {
                                endpoint: 'installed'
                            },
                            {
                                endpoint: 'import',
                                value: uploadId
                            }
                        ]),
                        isAPIv2: true
                    }).post().done(_.bind(function (result) {
                        loader.remove();
                        this.fileUploader.remove();
                        this.collection.add(result.lineItems);
                        this.renderDatatable();
                    }, this)).fail((err) => {
                        if (err && err.responseJSON) {
                            loader.remove();
                            let file = this.fileUploader.collection.models[0];
                            this.fileUploader.collection.remove(file);
                            this.fileUploader.render();
                            this.fileUploader.showError(err.responseJSON.message, 10000);
                        }
                    });
                }, this)
            });
        } else {
            // Hide file uploader if button is clicked again
            $uploader.attr('hidden', !$uploader.attr('hidden'));
        }
        let self = this;
        $uploader.find('.btn-download-template').off('click').on('click', self.downloadImportTemplate);
    },
    getCostCodeOptions: function (model) {
        let subJob = this.subJobs.get(model.get('subJobId')),
            costCodes = [],
            filteredCostCodes = _.filter(this.costCodes.models, (costCode) => {
                let productionQuantity = this.options.productionQuantities.findWhere({costCodeId: costCode.get('id')});
                if (subJob == null) {
                    return costCode.get('subJobId') == null && productionQuantity != null;
                }
                return costCode.get('subJobId') === subJob.id && productionQuantity != null;
            });

        if (_.size(filteredCostCodes) === 0) {
            return [{
                id: 0,
                name: 'No cost codes found',
                disabled: true
            }];
        }

        _.each(filteredCostCodes.sort((c1, c2) => {
            return PJQ.helpers.sortHelpers.sortAlphaNum(c1.get('code'), c2.get('code'));
        }), function (costCode) {
            let choice = {
                id: costCode.id,
                name: costCode.getDisplayName()
            };
            costCodes.push(choice);
        }, this);
        return costCodes
    },
    addQuantity: function () {
        let newModel = new PJQ.models.productionQuantities.InstalledQuantity({
            projectId: this.options.project.id,
            quantity: 0,
            description: '',
            productionQuantityId: this.options.productionQuantityId,
            timeCardId: this.options.timeCardId,
            installedOn: new Date()
        });
        this.collection.add(newModel);
        this.renderDatatable();
    },
    saveQuantities: function () {
        if (!this.validate())
            return;

        let modelsToSave = _.filter(this.collection.models, (model) => {
            return model.isNew() || model.hasChanged();
        });

        let modelsToSaveJSON = _.map(modelsToSave, (model) => model.toJSON());

        if(_.size(modelsToSaveJSON) > 0) {
            this.collection.saveBulk(modelsToSaveJSON, (savedQuantities) => {
                PJQ.notifications.notify.successNotify({
                    message: 'Quantities saved successfully'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(savedQuantities);
                }
            });
        } else{
            if (typeof this.options.onSave === 'function') {
                this.options.onSave([]);
            }
        }
    },

    validate: function () {
        let isValid = true;

        _.each(this.collection.models, (model) => {
            isValid = isValid && this.validateQuantity(model);
        })

        return isValid;
    },
    validateQuantity: function (quantity) {
        if (this.dataTable == null) {
            return true;
        }

        let row = this.dataTable.getRow(quantity.cid),
            data = row?.data(),
            result = true,
            updateCell = _.bind(function ($cell, isValid) {
                if (isValid) {
                    $cell.removeClass('bg-danger-transparent');
                } else {
                    $cell.addClass('bg-danger-transparent');
                }
                result = result && isValid;
            }, this);

        if (data == null || data.get('delete')) {
            return true;
        }

        if (row != null) {
            let costCodeCol = 0,
                uomCol = 1,
                installedOnCol = 4;
            if (_.size(this.subJobs.models) > 0) {
                costCodeCol++;
                uomCol++;
                installedOnCol++;
            }

            if(this.options.productionQuantityId > 0 && quantity.get('productionQuantityId') == null) {
                quantity.set('productionQuantityId', this.options.productionQuantityId);
            }

            if(this.options.timeCardId > 0 && quantity.get('timeCardId') == null) {
                quantity.set('timeCardId', this.options.timeCardId);
            }

            let productionQuantity = this.options.productionQuantities.findWhere({id: quantity.get('productionQuantityId')});
            if (this.options.productionQuantityId > 0) {
                installedOnCol = installedOnCol - (_.size(this.subJobs.models) > 0 ? 3 : 2);
            } else if(productionQuantity == null) {
                updateCell($(row.nodes()[0]).find('td:eq(' + costCodeCol + ')'), quantity.get('costCodeId') > 0);
                updateCell($(row.nodes()[0]).find('td:eq(' + uomCol + ')'), quantity.get('unitId') > 0);
            }

            updateCell($(row.nodes()[0]).find('td:eq(' + installedOnCol + ')'), quantity.get('installedOn') != null);
        }
        return result;
    },
    deleteQuantityClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteQuantity(row.data());
    },
    deleteQuantity: function (quantity) {
        let row = this.dataTable.getRow(quantity.cid);

        if(quantity.isNew()){
            quantity.destroy();
        } else {
            quantity.set('delete', true);
        }
        this.dataTable.removeRow(row);
    }
});